var version = require("./version")

module.exports = isVirtualText

function isVirtualText(x) {
    return x && x.type === "VirtualText" && x.version === version
}



// WEBPACK FOOTER //
// ./node_modules/virtual-dom/vnode/is-vtext.js